<template>
  <div class="database-query-container">
    <div class="database-query-header">
      <h2>SQL 查询编辑器</h2>
    </div>
    <el-card shadow="hover" class="database-query-card">
      <div class="query-editor">
        <el-form ref="queryForm" :model="queryForm" label-position="top">
          <el-form-item label="SQL 语句">
            <el-input
              v-model="queryForm.sql"
              placeholder="请输入 SQL 语句"
              type="textarea"
              rows="10"
              resize="vertical"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="executeQuery" :loading="loading">执行查询</el-button>
            <el-button @click="clearQuery">清空</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 查询结果展示 -->
      <div class="query-result" v-if="result">
        <el-divider>查询结果</el-divider>
        <div v-if="result.success">
          <el-table :data="result.data" style="width: 100%" v-if="result.data && result.data.length > 0">
            <el-table-column
              v-for="(value, key) in result.data[0]"
              :key="key"
              :prop="key"
              :label="key"
            ></el-table-column>
          </el-table>
          <div class="no-data" v-else>
            查询结果为空
          </div>
        </div>
        <div v-else>
          <el-alert
            title="查询失败"
            :description="result.error"
            type="error"
            show-icon
            :closable="false"
          ></el-alert>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'DatabaseQuery',
  data() {
    return {
      databaseId: this.$route.params.databaseId,
      queryForm: {
        sql: ''
      },
      result: null,
      loading: false
    }
  },
  methods: {
    async executeQuery() {
      if (!this.queryForm.sql.trim()) {
        this.$message.warning('请输入 SQL 语句')
        return
      }

      this.loading = true
      try {
        const response = await this.$axios.post(
          `/projects/${this.$route.query.projectId}/databases/${this.databaseId}/query`,
          this.queryForm
        )
        this.result = response.data
      } catch (error) {
        this.result = {
          success: false,
          error: error.response?.data?.error || '查询失败，请检查 SQL 语句'
        }
      } finally {
        this.loading = false
      }
    },
    clearQuery() {
      this.queryForm.sql = ''
      this.result = null
    }
  }
}
</script>

<style scoped>
.database-query-container {
  width: 100%;
}

.database-query-header {
  margin-bottom: 20px;
}

.database-query-header h2 {
  margin: 0;
  color: #303133;
}

.database-query-card {
  margin-bottom: 20px;
}

.query-editor {
  margin-bottom: 20px;
}

.query-result {
  margin-top: 20px;
}

.no-data {
  text-align: center;
  padding: 20px;
  color: #909399;
}
</style>
